<template>
    <!--Le code HTML dans la balise template-->
    <v-sheet>
        <v-card class="mx-auto px-6 py-8" style="width:50%;background-color:#01358D;color:white">
            <p>{{message}}</p>
            <router-link :tag="div" :to="{name:'Accueil'}">Connectez vous</router-link>
        </v-card>
    </v-sheet>
</template>

<script>
    import { defineComponent } from 'vue';

    export default defineComponent({
        components: {
            //Les composants
        },
        // Données du composant
        data: function () {
            return {
                message: 'Votre inscription a bien été prise en compte. Veuillez consulter le mail qui vous a été envoyé afin de valider votre inscription.'
            }
        },
        //Données calculé du composant
        computed: {
            //données calculé
        },
        //Méthodes et fonctions du
        methods: {
        },

        // Variables  passées en paramétre
        props: {

        },
        // fonction s'éxécurant lorsque le composant est monté
        // elle est exécuté avant la création du composant
        mounted() {

        }
        ,
        // fonction s'éxécurant lorsque le composant est crée
        // elle est exécuté avant le rendu du composant
        created() {

        }
    });
</script>